module.exports = __webpack_public_path__ + "media/images/icons/tag-blue-a67c99538e58b67bbe17c2162fa99be9.svg";